import React, {
  useState,
  useRef,
  useCallback,
  useMemo,
  useEffect,
} from "react";
import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  useNodesState,
  useEdgesState,
  Controls,
  MarkerType,
} from "reactflow";
import "reactflow/dist/style.css";
import HomeHeader from "../HomeHeader";
import { GetWorkflowData } from "../utilities/WorkFlowUtilities";

import Sidebar from "./Sidebar";
import CustomNodePlatformData from "./CustomNodePlatfromData";
import CustomNodeFilterData from "./CustomNodeFilterData";
import CustomNodeAnonProtocol from "./CustomNodeAnonProtocol";
import CustomNodeQRConfig from "./CustomNodeQRConfig";
import CustomNodePushBack from "./CustomNodePushBack";
import CustomNodeHL7Sender from "./CustomNodeHL7Sender";
import CustomNodeHL7Filter from "./CustomNodeHL7Filter";
import CustomNodeHl7Config from "./CustomNodeHL7Configs";
import SideBar from "../SideBar/SideBar";

import "./index.css";
import CustomNodePacsRecepients from "./CustomNodePacsRecepients";
import CustomNodePacsDestination from "./CustomNodePacsDestination";
import { useParams } from "react-router-dom";
import { ColorLensOutlined } from "@mui/icons-material";

const initialNodes = [
  // {
  //   id: "1",
  //   type: "input",
  //   data: { label: "input node" },
  //   position: { x: 250, y: 5 },
  // },
];
// const nodeTypes = {
//   PlatFormNode: CustomNodePlatformData,
//   FilterNode: CustomNodeFilterData,
//   AnonNode: CustomNodeAnonProtocol,
//   PACSRecNode: CustomNodePacsRecepients,
//   PACSDestNode: CustomNodePacsDestination,
//   QRConfigNode: CustomNodeQRConfig,
//   PushBackNode: CustomNodePushBack,
//   HL7SenderNode: CustomNodeHL7Sender,
//   HL7FiltersNode: CustomNodeHL7Filter,
//   HL7ConfigsNode: CustomNodeHl7Config,
// };

let id = 0;
const getId = () => `dndnode_${id++}`;


let usedColors = [];

const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  
  do {
    color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
  } while (usedColors.includes(color));
  
  usedColors.push(color);
  return color;
};

const DnDFlow = () => {
  const reactFlowWrapper = useRef(null);
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);

  let { routerID } = useParams();

  useEffect(() => {
    const fetchWorkflowData = async () => {
      try {
        let response = await GetWorkflowData(routerID);

        setNodes(response?.node_list);

        setEdges(
          response?.edge_list.map(edge => ({
            ...edge,
            style: { strokeWidth: 4,stroke:getRandomColor() }, // Set the thickness of the edges
            markerEnd: {
              type: MarkerType.ArrowClosed,
              color:'black' // Add an arrow to the end of the edge
            },
          }))
        );
        // Handle the response and update the state accordingly
      } catch (error) {
        console.error("Error fetching workflow data:", error);
      }
    };

    fetchWorkflowData();
  }, [routerID]);
  const onConnect = useCallback(
    (params) => setEdges((eds) =>
      addEdge(
        { ...params, style: { strokeWidth: 4,color:'black' }, markerEnd: { type: MarkerType.ArrowClosed } },
        eds
      )
    ),
    []
  );

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }, []);

  const onDrop = useCallback(
    (event) => {
      event.preventDefault();

      const type = event.dataTransfer.getData("application/reactflow");

      // check if the dropped element is valid
      if (typeof type === "undefined" || !type) {
        return;
      }

      const position = reactFlowInstance.project({
        x: event.clientX,
        y: event.clientY,
      });
      const newNode = {
        id: getId(),
        type,
        position,
        data: { id: "" },
      };

      setNodes((nds) => nds.concat(newNode));
    },
    [reactFlowInstance, setNodes]
  );

  const handleDataChange = useCallback(
    (id, nodeData) => {
      setNodes((nds) =>
        nds.map((node) =>
          node.id === id
            ? {
                ...node,
                data: nodeData,
              }
            : node
        )
      );
    },
    [setNodes]
  );

  const nodeTypes = useMemo(
    () => ({
      PlatFormNode: (props) => (
        <CustomNodePlatformData {...props} onChange={handleDataChange} />
      ),
      FilterNode: (props) => (
        <CustomNodeFilterData {...props} onChange={handleDataChange} />
      ),
      AnonNode: (props) => (
        <CustomNodeAnonProtocol {...props} onChange={handleDataChange} />
      ),
      PACSRecNode: (props) => (
        <CustomNodePacsRecepients {...props} onChange={handleDataChange} />
      ),
      PACSDestNode: (props) => (
        <CustomNodePacsDestination {...props} onChange={handleDataChange} />
      ),
      QRConfigNode: (props) => (
        <CustomNodeQRConfig {...props} onChange={handleDataChange} />
      ),
      PushBackNode: (props) => (
        <CustomNodePushBack {...props} onChange={handleDataChange} />
      ),
      HL7SenderNode: (props) => (
        <CustomNodeHL7Sender {...props} onChange={handleDataChange} />
      ),
      HL7FiltersNode: (props) => (
        <CustomNodeHL7Filter {...props} onChange={handleDataChange} />
      ),
      HL7ConfigsNode: (props) => (
        <CustomNodeHl7Config {...props} onChange={handleDataChange} />
      ),
    }),
    [handleDataChange]
  );

  // console.log("nodes", nodes);

  return (
    <>
      <div>
        <SideBar />
      </div>
      <div>
        {" "}
        <HomeHeader />
      </div>
      <div className="dndflow">
        <ReactFlowProvider>
          <div></div>
          <div
            className="reactflow-wrapper"
            ref={reactFlowWrapper}
            style={{
              border: "1px solid green ",
              height: "46rem",
              background: "white",
            }}
          >
            <ReactFlow
              nodes={nodes}
              edges={edges}
              nodeTypes={nodeTypes}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onConnect={onConnect}
              onInit={setReactFlowInstance}
              onDrop={onDrop}
              onDragOver={onDragOver}
              // defaultViewport={{ x: 0, y: 0, zoom: 0.7 }}
              fitView
            >
              <Controls />
            </ReactFlow>
          </div>
          <Sidebar />
        </ReactFlowProvider>
      </div>
    </>
  );
};

export default DnDFlow;
